import React, { useState } from 'react';
import PageHeader from '../../components/PageHeader/PageHeader';
import MetricRow from '../../components/MetricRow/MetricRow';
import MetricCard from '../../components/MetricCard/MetricCard';
import Badge from '../../components/Badge/Badge';
import Button from '../../components/Button/Button';
import Modal from '../../components/Modal/Modal';
import styles from './ParticipantProfile.module.css';

const ParticipantProfile = () => {
  const [showSuspendModal, setShowSuspendModal] = useState(false);
  const [suspendReason, setSuspendReason] = useState('Multiple accounts / duplicate device');
  const [suspendNotes, setSuspendNotes] = useState('Found linked to duplicate device signatures.');

  const reasons = [
    'Multiple accounts / duplicate device',
    'Failed attendance',
    'Low quality responses',
    'Fraudulent documents'
  ];

  const headerBadge = <Badge variant="success">Verified</Badge>;

  const headerActions = (
    <Button
      variant="secondary"
      style={{ color: '#B3261E' }}
      onClick={() => setShowSuspendModal(true)}
    >
      Suspend account
    </Button>
  );

  const suspendModalFooter = (
    <>
      <Button variant="secondary" onClick={() => setShowSuspendModal(false)}>
        Cancel
      </Button>
      <Button variant="danger" onClick={() => setShowSuspendModal(false)}>
        Confirm suspension
      </Button>
    </>
  );

  return (
    <>
      <PageHeader
        backTo="/participants"
        backText="← Participants"
        title="Aman Sharma"
        badge={headerBadge}
        subtitle="Participant since Feb 2026 · Delhi NCR · 21 yrs · Male"
        actions={headerActions}
      />

      <MetricRow columns={4}>
        <MetricCard label="Studies completed" value="18" subtext="100% attendance" />
        <MetricCard label="Total earned" value="₹14,500" subtext="paid via UPI" />
        <MetricCard label="Reliability rating" value="4.95" subtext="out of 5.0" isGreen />
        <MetricCard label="Fraud flags" value="0" subtext="clean account" />
      </MetricRow>

      <div className={styles.mainGrid}>
        <section className={styles.card}>
          <h2 className={styles.cardTitle}>Participation history</h2>
          <div className={styles.historyList}>
            <div className={styles.historyRow}>
              <div>
                <div className={styles.historyTitle}>Footwear CLT · Gurugram</div>
                <div className={styles.historySubtitle}>Brandwise Consumer Labs · ₹600</div>
              </div>
              <span className={styles.paidBadge}>Paid · 20m ago</span>
            </div>
            <div className={styles.historyRow}>
              <div>
                <div className={styles.historyTitle}>MDR Audio Devices · Home visit</div>
                <div className={styles.historySubtitle}>Delhi Market Pulse · ₹1500</div>
              </div>
              <span className={styles.paidBadge}>Paid · Sep 26</span>
            </div>
            <div className={styles.historyRow}>
              <div>
                <div className={styles.historyTitle}>UPI App Usability Session</div>
                <div className={styles.historySubtitle}>FinTech Labs · ₹1000</div>
              </div>
              <span className={styles.paidBadge}>Paid · Sep 18</span>
            </div>
          </div>
        </section>

        <section className={styles.card}>
          <h2 className={styles.cardTitle}>Demographics & Verification</h2>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Phone</span>
            <span className={styles.detailValue}>+91 98712 34567</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>UPI ID</span>
            <span className={styles.detailValue}>amansharma@okaxis</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Student ID verification</span>
            <span className={`${styles.detailValue} ${styles.successValue}`}>Verified (DU)</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Device model</span>
            <span className={styles.detailValue}>OnePlus Nord CE 3</span>
          </div>
        </section>
      </div>

      <Modal
        isOpen={showSuspendModal}
        onClose={() => setShowSuspendModal(false)}
        title="Suspend participant"
        footer={suspendModalFooter}
        maxWidth={500}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '13px' }}>
          <span>Select violation reason</span>
          <div className={styles.reasonList}>
            {reasons.map((r) => (
              <button
                key={r}
                type="button"
                onClick={() => setSuspendReason(r)}
                className={`${styles.reasonBtn} ${suspendReason === r ? styles.reasonBtnActive : ''}`.trim()}
              >
                {r}
              </button>
            ))}
          </div>
        </div>

        <label style={{ display: 'flex', flexDirection: 'column', gap: '6px', fontSize: '13px' }}>
          <span>Internal admin notes</span>
          <textarea
            value={suspendNotes}
            onChange={(e) => setSuspendNotes(e.target.value)}
            className={styles.notesTextarea}
          />
        </label>
      </Modal>
    </>
  );
};

export default ParticipantProfile;
